import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../fonts.css';
import API_BASE_URL from '../api';

const ProfileDeletion = () => {
  const [password, setPassword] = useState(''); // getting password from user
  const [message, setMessage] = useState(''); // message to display
  const [confirmDelete, setConfirmDelete] = useState(false); // to confirm deletion
  const navigate = useNavigate(); // Initialize the useNavigate hook

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  }; // user password input

  // Utility function to get auth token from localStorage
  const getAuthToken = () => localStorage.getItem('stack_access_token');

  // to delete profile
  const handleDeleteProfile = async () => {
    const token = getAuthToken();
    // asks user to confirm profile deletion
    if (!confirmDelete) {
      setMessage('Please confirm profile deletion.');
      return;
    }

    try {
      const response = await fetch(`${API_BASE_URL}/api/profile/delete`, {
        method: 'DELETE',
        headers: {
          'X-Stack-Access-Token': token,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ password }),
      });

      if (response.ok) {
        const data = await response.json();
        setMessage(data.message);
        setTimeout(() => {
          navigate('/'); // Redirect to register after profile deletion
        }, 2000);
      } else {
        if (response.status === 404) {
          setMessage('Error deleting profile: Profile not found');
        } else {
          console.error('Error deleting profile:', response.json());
        }
      }
    } catch (error) {
      console.error('Error deleting profile:', error);
      setMessage('Error deleting profile. Please try again.');
    }
  };
  // to confirm deletion
  const handleConfirmDelete = () => {
    setConfirmDelete(true);
  };

  return (
    <div>
      <div className="bg-bggreen">
        <div
          className="max-w-md w-full mx-auto p-8 rounded-lg shadow-md"
          style={{ backgroundColor: '#05664f' }}
        >
          <h1
            className="text-5xl font-bold text-white text-center mb-6"
            style={{ fontFamily: 'Inter', textTransform: 'uppercase' }}
          >
            Delete Profile
          </h1>
          <form className="space-y-4">
            <div className="flex flex-col">
              <label htmlFor="password" className="text-white">
                Password:
              </label>
              <input
                type="password"
                id="password"
                name="password"
                placeholder="Enter your password here."
                value={password}
                onChange={handlePasswordChange}
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-d1ff5d focus:border-d1ff5d sm:text-sm"
                style={{ color: '#0d2329' }}
                required
              />
            </div>
            <div className="flex justify-center space-x-4">
              <button
                type="button"
                onClick={handleConfirmDelete}
                className="w-full px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                style={{ backgroundColor: '#000000' }}
              >
                CONFIRM DELETION
              </button>
              <button
                type="button"
                onClick={handleDeleteProfile}
                disabled={!confirmDelete} // Disable if confirmDelete is false
                className={`w-full px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 ${
                  !confirmDelete && 'opacity-50 cursor-not-allowed'
                }`}
                style={{ backgroundColor: '#000000' }}
              >
                DELETE PROFILE
              </button>
            </div>
          </form>
          {message && (
            <p className="text-sm text-red-200 text-center">{message}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProfileDeletion;
